<template>
  <InnerHeaderDiy />
  <div class="" style="margin:5rem 0 5rem ">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-11 col-md-11 col-xl-11 confirmpayment">
        <div class="row">
          <div class="col-md-5 p-3 rounded formobileview diy_left-panel">
             <ProductDetailsHeader v-if="productHeaderMount" :reviewData="this.apiReqData" :quoteRequest="this.quoteRequest" :quoteResponseDetails="this.quoteResponseDetails"/>
             <hr>
            <div class="row mt-3 d-flex justify-content-center">
                <!-- <div class="col-md-6">
                  <button class="backbutton" @click="editDIYSectionData()" v-if="(!errorInProposalSubmission || errorInProposalSubmission.length === 0) && (!displayApiErrorsOnUI || displayApiErrorsOnUI.length === 0)">Back</button>
                </div> -->
                <ConsentDaata :selected_plan_data="selected_plan_data" :checkedConditions="checkedConditions" @consent-status="condition = $event"  />
                <div class="mt-3 mb-2 errorMessage" :innerHTML="errorInProposalSubmission" />
                <div>
                  <p class="my-1 errorMessage" v-for="error in displayApiErrorsOnUI" :key="error">{{error}}</p>
                </div>
            </div>
            <div style="position: sticky;top: 5rem" class="d-none">
              <div class="headingcards mt-3" v-for="item in items" :key="item.heading">
                <h3>{{ item.heading }}</h3>
                <img class="confirmimage"
                  :src="this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.supportingData.insCompanyLogo"
                  alt="Bank Logo" />
                <div class="d-flex align-items-center mt-3 justify-content-between">
                  <p>{{ item.planType }}</p>
                  <h4>{{this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.insuranceAndProducts.policyType }}</h4>
                </div>
                <div class="d-flex align-items-center justify-content-between" v-if="this.quoteResponseDetails?.quote_response_data.insuranceAndProducts.policyType!=='StandaloneTP(1)'">
                  <p>{{ item.coverType }}</p>
                  <h4>{{ this.quoteResponseDetails &&
                    currency(this.quoteResponseDetails.quote_response_data.supportingData.insuredDeclaredValue.suggestedIDV)
                    }}
                  </h4>
                </div>
                <hr />
                <div class="d-flex align-items-center gap-1 specifications">
                  <img src="../../assets/images/checksvg.svg" width="10px" />

                  <p>{{ this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.supportingData.usp1
                    }}</p>
                </div>
                <div class="d-flex align-items-center gap-1 specifications">
                  <img src="../../assets/images/checksvg.svg" width="10px" />

                  <p>{{ this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.supportingData.usp2
                    }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-center mt-3 justify-content-between">
                  <p>{{ item.premiumAmount }}</p>
                  <h4>{{ this.quoteResponseDetails &&
                    currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumValueBeforeTax)
                    }}</h4>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p>{{ item.GSTType }}</p>
                  <h4>{{ this.quoteResponseDetails &&
                    currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalTax)}}
                  </h4>
                </div>
                <hr />
                <div class="d-flex align-items-center justify-content-between">
                  <h4>{{ item.amountTitle }}</h4>
                  <h6>{{ this.quoteResponseDetails &&
                    currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumWithTax)
                    }}</h6>
                </div>

                <div class="text-end">
                <!-- <a href="#" style="font-size: 12px;text-decoration: underline;" data-bs-toggle="modal" data-bs-target="#amountBreakup">Show Breakup</a> -->
                <span @click="showBreakupmodal()" class="text-primary" style="font-size: 12px;text-decoration: underline;cursor: pointer;">Premium Breakup</span>
                <!-- <a href="#" @click.prevent="showBreakupmodal"><p>Show Breakup</p></a> -->
              </div>
              </div>
              
            </div>
          </div>
          <div class="col-md-7">
           
            <div class="formWizard position-sticky review-panel p-4 " style="top: 5rem;display: flex;flex-direction: column;justify-content: center;align-items: start; width:100%">
              <h3 class="processheading">
                Confirm & Proceed
              </h3>

              <!-- <article class="FilterAccordian headingcards" v-if="this.structuredJSON && this.structuredJSON.addOns">
                <header class="d-flex justify-content-between align-items-center"
                  :class="{ 'border-bottom pb-2': this.structuredJSON.addOns.expanded }"
                  @click="this.structuredJSON.addOns.expanded = !this.structuredJSON.addOns.expanded">
                  <h6 class="question-title mb-0">
                    Add Ons
                  </h6>
                  <button class="btn p-0">
                    <img src="../../assets/images/minus.svg" class="plusminusicon"
                      v-show="this.structuredJSON.addOns.expanded" />

                    <img src="../../assets/images/plus.svg" class="plusminusicon"
                      v-show="!this.structuredJSON.addOns.expanded" />

                  </button>
                </header>
                <div>
                  <transition name="fade" mode="out-in">
                    <div v-if="this.structuredJSON && this.structuredJSON.addOns.expanded">
                      <div class="d-flex gap-2 addonplan align-items-center pb-2"
                        v-for="(addons, index) in this.structuredJSON.addOns.data" :key="addons.optionSelected" :class="{'my-3': index != this.structuredJSON.addOns.data.length-1}">
                        <input class="form-check-input" type="checkbox" :value="addons.optionSelected"
                          id="flexCheckDefault" checked disabled>
                        <label>
                          <h5 class="mb-0">{{ addons.optionDescription }}</h5>
                        </label>
                      </div>
                    </div>
                  </transition>
                </div>
              </article> -->

              <template v-if="this.structuredJSON">
                <article class="FilterAccordian headingcards mt-3" v-for="details in filteredStructureJson"
                  :key="details.id" v-show="!(details.name === 'previousPolicyDetails' && quoteCategory === 'New')">
                  <header class="d-flex justify-content-between align-items-center"
                    :class="{ 'border-bottom pb-2': details.expanded }" @click="details.expanded = !details.expanded">
                    <h6 class="question-title mb-0">
                      {{ details.label }}
                    </h6>
                    <div class="d-flex gap-2 align-items-center">
                      <button @click="editDIYSectionData(details.name)" class="btn d-flex align-items-center gap-1" v-if="isEditButton">
                        <span class="edit_text">Edit</span>
                        <img src="@/assets/images/edit-pencil.png" class="editButton"/>
                      </button>
                      <button class="btn p-0">
                        <img src="../../assets/images/minus.svg" class="plusminusicon" v-show="details.expanded" />

                        <img src="../../assets/images/plus.svg" class="plusminusicon" v-show="!details.expanded" />

                      </button>
                    </div>
                  </header>

                  <transition name="fade" mode="out-in">
                    <div v-if="details.expanded" :class="{'col-12': details.name!='nomineeInfo', 'row p-3': details.name=='nomineeInfo'}">
                      <template v-if="details.fieldGroups">
                        <div class="fieldgrp row" v-for="fieldFirst in Object.values(details.fieldGroups)"
                          :key="fieldFirst.id">
                          <h6 class="headinglables" v-if="displaySubHeading(fieldFirst)">{{ fieldFirst.label }}</h6>
                          <template v-if="fieldFirst.fields">
                            <div v-for="fieldSecond in Object.values(fieldFirst.fields)" :key="fieldSecond.id" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-show="fieldSecond.input !== '' && (!fullNameExists() || !isNameField(fieldSecond.label))">
                              <div :class="['content', !(fieldSecond.name === 'rtoCode' || fieldSecond.name === 'vehicleNumber') && 'mt-3']">
                                <div :class="['content', !(fieldSecond.name === 'rtoCode' || fieldSecond.name === 'vehicleNumber') ? 'd-flex flex-column mb-2' : 'd-flex flex-column mb-0']" v-if="fieldSecond.input !== '' && (!fullNameExists() || !isNameField(fieldSecond.label))" style="gap:8px">
                                  <template v-if="fieldSecond.name === 'rtoCode'">
                                    <template v-if="quoteCategory=='New'">
                                      <p class="diy_label mb-0">Registration Number</p>
                                      <h5 class="mb-0 text-uppercase">{{ Object.values(fieldFirst.fields).find(f => f.name === 'rtoCode')?.input }}</h5>
                                    </template>
                                  </template>
                                  <template v-else-if="fieldSecond.name === 'vehicleNumber'">
                                    <p class="diy_label mb-0">Registration Number</p>
                                    <h5 class="mb-0 text-uppercase">{{ Object.values(fieldFirst.fields).find(f => f.name === 'rtoCode')?.input }}{{Object.values(fieldFirst.fields).find(f => f.name === 'vehicleNumber')?.input}}</h5>
                                  </template>
                                  <template v-else>
                                  <p class="diy_label mb-0">{{ fieldSecond.label }}</p>
                                  <h5 v-if="fieldSecond.type=='date'" class="mb-0 text-uppercase" >{{ formatDateToMonthString(fieldSecond.input)}}</h5>
                                  <h5 v-else class="mb-0 text-uppercase">{{ (fieldSecond.input != '' && fieldSecond.input == '0') ? 'No' :
                                    (fieldSecond.input != '' && fieldSecond.input == '1') ? 'Yes' :
                                    capitalizeFirstLetter(fieldSecond.input,fieldSecond.label) }}</h5>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="fieldFirst.fieldGroups">
                            <div v-for="fieldSecond in Object.values(fieldFirst.fieldGroups)" :key="fieldSecond.id" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 " v-show="fieldSecond!= undefined && fieldSecond.input != ''">
                              <div class="content mt-3 " v-if="fieldSecond!= undefined && fieldSecond.input != ''">
                                <div class="d-flex flex-column mb-2" style="gap:8px">
                                  <p class="diy_label mb-0">{{ fieldSecond.label }}</p>
                                  <h5 v-if="fieldSecond.type=='date'" class="mb-0 text-uppercase" >{{ formatDateToMonthString(fieldSecond.input)}}</h5>
                                  <h5 v-else class="mb-0 text-uppercase">{{ (fieldSecond.input != '' && fieldSecond.input == '0') ? 'No' :
                                    (fieldSecond.input != '' && fieldSecond.input == '1') ? 'Yes' :
                                    capitalizeFirstLetter(fieldSecond.input,fieldSecond.label) }}</h5>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-if="details.fields">
                        <div :class="{'fieldgrp row': details.name!='nomineeInfo', 'fieldgrp col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6': details.name=='nomineeInfo' }"  v-for="fieldFirst in Object.values(details.fields)" :key="fieldFirst.id" v-show="fieldFirst!= undefined && fieldFirst.input != ''">
                          <div class="content mt-3" v-if="fieldFirst!= undefined && fieldFirst.input != ''">
                            <div class="d-flex flex-column mb-2" style="gap:8px">
                              <p class="diy_label mb-0">{{ fieldFirst.label }}</p>
                              <h5 class="mb-0 text-uppercase">{{ (fieldFirst.input != '' && fieldFirst.input == '0') ? 'No' :
                                (fieldFirst.input != '' && fieldFirst.input == '1') ? 'Yes' :
                                capitalizeFirstLetter(fieldFirst.input,fieldFirst.label) }}</h5>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </transition>
                </article>
              </template>
              
              <div class="col-md-12 mt-4 w-100">
                <button class="btn commonButton mb-2" @click="openOtpVerifyModal()" :disabled="selected_plan_data && selected_plan_data.supportingData && selected_plan_data.supportingData?.userConsent && selected_plan_data.supportingData?.userConsent[0]?.condition ? !condition : false">Submit</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
  <div class="modal fade" id="pollingModal" tabindex="-1" aria-labelledby="pollingModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="pollingModalLabel">Polling Complete</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            The polling process is complete. We have received the data successfully!
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="proceedWithData" :disabled="loadingState">Proceed</button>
          </div>
        </div>
      </div>
    </div>
  <OtpVerification v-if="this.otpOpenModalFlag" @close-modal="handleOtpVerifyModal" @resend-otp="resendOtp" :time="time"
    @set-timer="updateTime" @show-error-message="setErrorMessage" />
  <VarificationModal />
  <AmountBreakup v-if="this.openAmountBreakupflag" @emitClose="emitClose()"/>
  <!-- <verifypremium v-if="this.verifypremiumflag" @emitVerifyClose="emitVerifyClose()" @openOtpModal="openOtpVerifyModal()"/> -->
  <Verifypremium v-if="Verifypremiumflag" @emitVerifyClose="VerifymodalClose" @emitcontinueNewPremium="continueNewPremium"/>
  <pageLoader :msg="loadingMessage" v-if="loadingState || !this.quoteResponseDetails" />
</template>

<script>
import VarificationModal from "@/modals/varificationModal.vue";
import OtpVerification from "./OtpVerification.vue";
import pageLoader from "../pageLoaders/pageLoader.vue";
import InnerHeaderDiy from "../header/innerHeaderDiy.vue";
import AmountBreakup from "@/modals/amountBreakup.vue";
import ProductDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import { getDistributer} from '@/mixins/common';
import Verifypremium from "@/modals/verifypremium.vue";
import ConsentDaata from "./ConsentDaata.vue";
import { stripHtml } from '@/utils/inputSanitizer';
import { navigateToPaymentStatusOutcome } from '@/lib/payment/navigate-payment-outcome';
import {
  DIY_PROPOSAL_ERROR_STORAGE_KEY,
  PAYMENT_STATUS_OUTCOME_FAILURE,
  PAYMENT_STATUS_OUTCOME_INSPECTION,
  PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
  PAYMENT_STATUS_OUTCOME_SUCCESS,
  PAYMENT_STATUS_PATH,
} from '@/lib/payment/payment-status-constants';
export default {
  components: {
    OtpVerification,
    VarificationModal,
    pageLoader,
    InnerHeaderDiy,
    AmountBreakup,
    ProductDetailsHeader,
    Verifypremium,
    ConsentDaata
  },
  mixins: [getDistributer],
  methods: {
    fullNameExists() {
      return !!this.proposalDetails?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields 
            && !!this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName?.input?.trim();
    },
    isNameField(label) {
      return ['First Name', 'Middle Name', 'Last Name'].includes(label);
    },
    formatDateToMonthString(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-');
    },
    editDIYSectionData(label='proposerDetails'){
      sessionStorage.setItem('currentTab', JSON.stringify(label));
      sessionStorage.setItem('filledDataTab', JSON.stringify(label));
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      userData.regNumber = this.proposalDetails.proposal_json.fieldGroups.vehicleDetails.fieldGroups.makeModelVariantDetails.fields.vehicleNumber.input;
      sessionStorage.setItem("userData", JSON.stringify(userData));
      setTimeout(() => {
        this.$router.push('/process-wizard');
      }, 200);
    },
    VerifymodalClose(){
     this.Verifypremiumflag=false;

    },
    continueNewPremium(){
      this.Verifypremiumflag=false;
      this.updateProposalStatus(11);
    },
    compareValues(dataArray, dataObject) {
    for (const item of dataArray) {
      const proposalValue = this.getValueFromPath(dataObject, item.proposalPath);
      const singleQuoteValue = this.getValueFromPath(dataObject, item.singleQuotePath);

      if (proposalValue !== singleQuoteValue) {
        console.log("proposalValue ", proposalValue, singleQuoteValue);
        this.Sqflag = true;
        if(this.Sqflag){
        this.getSingleQuote()
      }
        break;
      }
     
    }
    if(!this.Sqflag){
      this.updateProposalStatus(11)
    }
    console.log("sqflag",this.Sqflag)
  },
  getValueFromPath(object, path) {
    return path.split('.').reduce((acc, key) => acc && acc[key], object);
},
getCkycDetails() {
      this.loadingState = true;
      this.loadingMsg="Fetching CKYC Details"
      var self = this;
      // this.loading = true;
      this.kycRedirectUrl = "";
      this.msg = [];

      let reqData = {
        "personalInformation": {
          "dateOfBirth": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input,
          "email": "",
          "mobileNumber":this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.input ,
          "zipCode": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input,
          "pan": this.PANNumber,
          //Gender For Testing
          "gender":"male"
        },
        "product": {
          "insuranceCompanyCode": this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
          "productId": this.selectedPlan.insuranceAndProducts.productCode,
        },
        "trackInfo": {
          "manufacturerQuoteID": this.uniqueQuoteId.toString(),
          "manuApplicationNo":"" ,
          "KYCRequestID": ""
        },
        "distributor": {
          "distributorID":this.distributorID,
          "agentID": this.getAgentIdFromRmData(this.rmData),
          "salesChannel": "online",
          "channelType": this.rmData.RoleId !== "1" ? "B2B" : "B2C",
        },
        "kycInfo": {
          "ReturnURL": "https://www.1silvebullet.tech"  
        },
        "journey_id": this.journey_id,
      };

      // Save request json  
      //sessionStorage.setItem("request_json", JSON.stringify(reqData));
      let headers = {"Authorization":`Bearer ${ this.$store.state.token}`};
      console.log('calling kyc...')
      this.backendApi("getCkyc", reqData, headers)
        .then((response) => {
          this.loadingState=false;
          
          this.kycResponse = response?.data?.data;
          this.kycStatus = this.kycResponse?.kycInfo?.Status;

          if(response.data.errors.length > 0) {
            for(let i=0; i<response.data.errors.length; i++)
            {
              this.msg.push('Verify that your PAN-Date of Birth combination is correct and try again. If the issue continues, please contact the support staff.');
            } 
          } else if(this.kycStatus == "approved") {
            this.loadingState = false;
            if(this.newsqData.productDetails.totalPremiumDetails[0].totalPremiumWithTax!==this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumWithTax){
              this.Verifypremiumflag=true;
            }
            else{
              this.updateProposalStatus(11);
            }
            // this.$router.push({ path: '/process-wizard' })
            sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
            // let userData = JSON.parse(sessionStorage.getItem("userData")); 
            // setTimeout(function() { 
            //   self.$router.push("/process-wizard");
            // }, 2000);            
          } else if(response.data.data.kycInfo.Status == null && response.data.data.kycInfo.RedirectURL == null) {
            
            // this.getCkycDetails2();

          } else if((this.kycStatus == "Pending" || this.kycStatus == "POAIncomplete" || this.kycStatus == "Incomplete")) {
            this.isUploadDocRequired = true;
          } else  {
            sessionStorage.removeItem('kyc_response');
            this.kycRedirectUrl = this.kycResponse.kycInfo.RedirectURL;
            setTimeout(function() { 
              window.open(self.kycRedirectUrl, '_blank').focus();
            }, 2000);
          }

        })
        .catch((error) => {
          console.log('error msg block : get kyc', error);
          self.loading = false;
        }); 
    },
    getSingleQuote() {
      // var self = this;
      // self.loading2 = true;
      this.loadingState = true;
      this.loadingMessage = "Submitting Proposal to insurer… Please wait";
      console.log("this.requestBody", this.apiReqData)
      let checkUserType = JSON.parse(sessionStorage.getItem('user-type'));
      let corporateName = JSON.parse(sessionStorage.getItem("filledData"));
      if(checkUserType && corporateName && checkUserType=='corporate'){
        this.apiReqData.personalInformation.individualDetails[0].firstName = corporateName.fieldGroups.proposerDetails.fieldGroups.corporateDetails.fields.nameOfCaompany.input;
      }else{
        this.apiReqData.personalInformation.individualDetails[0].firstName = corporateName.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input;
        this.apiReqData.personalInformation.individualDetails[0].lastName = corporateName.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input;
      }
      this.apiReqData.product.ncbDetails.claimLastYearFlag = this.apiReqData.personalInformation.individualDetails[0].isOwnerTransfer  ? true : false;
      this.apiReqData.product.ncbDetails.numberOfClaims = this.apiReqData.personalInformation.individualDetails[0].isOwnerTransfer ? 1 : 0;
      
      sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
      this.backendApi("quotationApi", this.apiReqData, { "Authorization": `Bearer ${this.$store.state.token}` }, "post")
        .then((response) => {
          console.log("inside response sq")
          if (response.data.errors.length > 0) {
            this.displayApiErrorsOnUI = [];
            // this.loading = false;
            this.loadingState = false;
      
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
            }
            console.log("Errors in Response", msg)
            this.displayApiErrorsOnUI = msg;
            // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
          } else if (response && response.data) {
            
            this.requestId = response.data.reqId;
            // this.loading = false;
            if (response?.data?.data?.quote?.length > 0) {
              console.log("inside loop for")
              this.responseData.push(response.data.data.quote)
            }
            if (response.data.errors.length == 0) {
              const self = this;
setTimeout(function () {
  self.pollapiflag = true;
  self.pollData();
}, 1000);

            }
            else {
              console.log("inside else case")
              this.loadingState = false;
              // this.loading2 = false;
              if (this.responseData.length == 0) {
                this.erMsg = 'No products found as per your selected filter. Please change the filters.';
                // self.beforeDestroy();
              }
            }
          }

        }).catch((error) => {
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.displayApiErrorsOnUI.push = msg;
          // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
        })
    },
    async getMotorProduct() {
      // this.loading2 = true;
      this.loadingState = true;
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestId];

      while (this.pollapiflag && (Date.now() - startTime) < maxPollingTime) {
        try {
          // if(this.$route.path !== "/policy-details"){
          //   this.pollapiflag = false;
          //   break;
          // }
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response.data.errors.length > 0) {
            this.loading = false;
            this.loadingState = false;
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
            }
            // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
            this.displayApiErrorsOnUI = msg;
          }
          if (response?.data?.data?.quote?.length > 0) {
            // this.loading2 = false;
            this.loadingState = false;
            this.suggestedIDV = response?.data?.data?.quote[0].supportingData.insuredDeclaredValue.suggestedIDV;
            this.responseData = response.data.data.quote;
            sessionStorage.setItem("quoteSingleData", JSON.stringify(this.responseData))
          }
          if (response.data.data.isPollComplete == true) {
            this.loadingState = false;
            this.pollapiflag = false;
            this.uniqueQuoteId=response.data.data.quote[0].trackInfo.manufacturerQuoteID;
            this.newsqData=response.data.data.quote[0];
            sessionStorage.setItem("updated_premium",JSON.stringify(this.newsqData));
            const isUploadDocRequired = sessionStorage.getItem("isUploadDocRequired") ? JSON.parse(sessionStorage.getItem("isUploadDocRequired")) : "";
            if(!isUploadDocRequired){
              this.getCkycDetails();
            }
            this.loading2 = false;
            // this.beforeDestroy();
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflag = true;
            }
          }
          await this.sleep(1000);
        }catch(err){
          console.log('error msg block', err);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflag = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    pollData() {
      console.log("polling")
        if (this.pollapiflag == true) {
          this.getMotorProduct();
        } else {
          // this.loading2 = false;
          if (this.responseData?.length == 0) {
            this.erMsg = 'No products found as per your selected filter. Please change the filters.';
          }
          // this.beforeDestroy();
        }
    },
    updateProposalStatus(statusid)
    {
        let qData = {
          "journey_id":this.journey_id,
          "status_id": statusid
          };
        var headers = {
          // "quoteId":this.uiQuoteId,
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
          "Content-Type": "application/json",
          };

          this.loadingState = true;
          this.loadingMessage = "Updating Proposal Status"
        
        this.backendApi("ProposalStatus", qData, headers)
          .then((response) => {
            this.loadingState = false;
            if(response == 'error') {
              self.apiError = true;
              
            }
           
             else if(response && response.data) {
              console.log('proposal status updated: ', response.data);
              if(statusid == 11 || statusid == 13)
              {
                if(response.data.status == "failed")
                {
                  let msg=['We are facing some issue while sending an e-mail']
                  this.$router.push({ path: '/networkalert', query: {backUrl:'proposal-details-check', msg: msg }});
                }
                else
                {
                  // this.$router.push('/confirm-payment-diy');
                }
              }
            }
          })
          .catch((error) => {
            this.loadingState = false;
            console.log('error msg block email', error);
            
          });
    },
    beforeDestroy() {
      this.disableButtons = false;
    },
    showBreakupmodal(){
      console.log("clicked-------");
      this.openAmountBreakupflag=true;
    },
    emitClose(){
      this.openAmountBreakupflag = false;
    },
    capitalizeFirstLetter(input, input2) {
      if(!input && !input2) return;

      if (input2 == "Date of Birth" || input2 == "Policy Expiry Date" || input2=="Previous Policy Expiry Date") {
        const date = new Date(input);
        if (isNaN(date.getTime())) return input; // Return original if invalid date

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return this.formatDateToMonthString(`${month}-${day}-${year}`);
      }
      if(input2=="Gender" || input2=="Marital Status" || input2=="Type of Finance" || input2=='Automobile Association' || input2=='Occupation'){
        return input.toUpperCase();
      }
      if (typeof input !== 'string' || input === '') return input;
      return input.charAt(0).toUpperCase() + input.slice(1);

    },
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getSPDetailsOneSB(man_code) {
      try {
        this.loadingState = true;
        this.loadingMessage = "Getting SP Details...";
        let reqData = [man_code];
        let headers = { "Authorization": `Bearer ${this.$store.state.token}` };

        const response = await this.backendApi("getSPDetailsOneSB", reqData, headers, "get");

        this.loadingState = false;

        if (response === 'error') {
          this.apiError = true;
        } else if (response && response.data) {
          
          console.log('response sp details: ', response.data);

          if (response.data.status === "failed") {
            // Handle redirection to error page and other necessary actions
            // this.$router.push({ path: '/error-page', query: { msg: "SP details not Available" } });
            this.displayApiErrorsOnUI.push("SP details not Available");
          }

          sessionStorage.setItem("sp_details_data", JSON.stringify(response.data));
        }
      } catch (error) {
        this.loadingState = false;
        console.log('error msg block spdetailOneSB API', error);
        // this.$router.push({ path: '/error-page', query: { msg: "SP details not Available" } });
        this.displayApiErrorsOnUI.push("SP details not Available");
      }
    },
    //get ProposalDetails
    async getProposalById(journey_id) {
      try {
        this.loadingState = true;
        this.loadingMessage = "Getting Proposal Details...";
        let qData = [journey_id, "Proposal Review", "false"];
        let headers = { "Authorization": `Bearer ${this.$store.state.token}` };

        const response = await this.backendApi("getProposalDetails", qData, headers, "get");
         if(this.channelType && !this.$route.query.response){
         
          
          if(this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING){
            // this.compareValues(this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING,response.data)
          }
         }
        

        this.apiReqData=response.data.data.quote_request.quote_request_json;
        this.$store.commit("setquoteCategory", this.apiReqData.quoteCategory);
        this.productHeaderMount = true;
        if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input){
        this.apiReqData.personalInformation.individualDetails[0].firstName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input){
        this.apiReqData.personalInformation.individualDetails[0].middleName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input){
        this.apiReqData.personalInformation.individualDetails[0].lastName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input){
        this.apiReqData.personalInformation.individualDetails[0].gender=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input){
        this.apiReqData.personalInformation.individualDetails[0].dateOfBirth=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input){
        this.apiReqData.personalInformation.individualDetails[0].email=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input
      }
      // 
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyEndDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyOdExpiryDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }

      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }

      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyOdNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        // this.apiReqData.product.previousPolicyDetails.previousPolicyTpExpiryDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyTpInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyTpNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      this.loadingState = false;
        if(!this.channelType){
          this.loadingState = false;
        }
        
        // console.log("request body",this.apiReqData?.personalInformation?.individualDetails[0]?.dateOfBirth)
        console.log("request body",this.apiReqData)
        
        
        sessionStorage.setItem("rm_data", JSON.stringify(response.data.data.user));
        this.proposalDetails = response.data.data.proposal;
        sessionStorage.setItem("propsalDetails_review", JSON.stringify(response.data.data));
        sessionStorage.setItem("filledData", JSON.stringify(this.proposalDetails.proposal_json));
        sessionStorage.setItem("proposal_ui_id", JSON.stringify(this.proposalDetails.proposal_ui_id));

        this.quoteDetails = response.data.data.quote_request;
        this.userDetails = response.data.data.user;

        sessionStorage.setItem("user_profile", JSON.stringify(this.userDetails));
        sessionStorage.setItem("quote_request", JSON.stringify(this.quoteDetails.quote_request_json));
        this.quoteRequest = response.data.data.quote_request;
        this.quoteResponseDetails = response.data.data.quote_response;
        let pln = this.quoteResponseDetails.quote_response_data;
        sessionStorage.setItem("selected_plan_data", JSON.stringify(pln));
        sessionStorage.setItem("quoteSingleData", JSON.stringify([pln]));
        this.selected_plan_data = pln;
        sessionStorage.setItem("selectedPlanForCheckout", JSON.stringify(pln));
        sessionStorage.setItem("journey_id", JSON.stringify(journey_id));
        this.$store.commit("setJourneyId", journey_id);

        if (this.proposalDetails.tag_name) {
          sessionStorage.setItem("filledDataTab", JSON.stringify(this.proposalDetails.tag_name));
          sessionStorage.setItem("currentTab", JSON.stringify(this.proposalDetails.tag_name));
        }
        let spdetail_flag = process.env.VUE_APP_SPDETAIL_ONESB;
        this.restructureJson();
        if (spdetail_flag == 1) {
          if (sessionStorage.getItem("rm_data")) {
            this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
            if (this.rmData['RoleId'] !== "1") {
              await this.getSPDetailsOneSB(this.proposalDetails.insurance_company_code);
            }
          }
        }

        if(response.data.errors.length > 0){ 
          for (let i = 0; i < response.data.errors.length; i++) {
            let ck = 1;
            this.errorInProposalSubmission += ck + '. ' + stripHtml(response.data.errors[i]["errorDisplayMessage"]) + '<br/>';
            ck++;
          }
        }
        const proposalResponse = response.data.data.proposal.proposal_response;
        if (proposalResponse && Object.keys(proposalResponse) && Object.keys(proposalResponse).length > 0) {
          const applicationStatus = await this.getProposalStatus(true);
          if (applicationStatus !== 'Scrutiny') {
            this.loadingState = false;
            return;
          } else {
            this.loadingState = true;
            const inspectionLink = proposalResponse?.inspectionDetails?.selfInspectionLink;
            const inspectionvalidTill = proposalResponse?.inspectionDetails?.inspectionValidTill;
            if (inspectionLink) {
              sessionStorage.setItem("inspectionLink", JSON.stringify(inspectionLink));
            }
            if (inspectionvalidTill) {
              sessionStorage.setItem("inspectionvalidTill", JSON.stringify(inspectionvalidTill));
            }

            sessionStorage.setItem("payment-url-response", JSON.stringify(proposalResponse.policy))
            sessionStorage.setItem("payment-poll-url", JSON.stringify(proposalResponse.ManufacturerTracking))
            navigateToPaymentStatusOutcome(this.$router, {
              outcome: PAYMENT_STATUS_OUTCOME_INSPECTION,
              journeyId: this.journey_id,
            });
            return;
          }
        }
       
      } catch (error) {
        this.loadingState = false;
        console.log("error msg block dp", error);
      }
    },
    restructureJson() {
      console.log("inside restructureJson",);
      let addOnsObject = {
        expanded: false,
        data: this.quoteResponseDetails.quote_response_data.productDetails.motorCovers,
        addOnSelected: []
      }
      this.structuredJSON.addOns = addOnsObject;
      const otherValues = Object.values(this.proposalDetails.proposal_json.fieldGroups)
        .filter(requiredFields => requiredFields.fieldGroups !== undefined)
        .filter(fields => fields.name != 'distributor')
        .map((item,index) => {
      return {
        ...item,
        expanded: index==0 ? true : false
      };
    });
      this.structuredJSON.otherRequiredFields = otherValues;

      // document.querySelectorAll('.form-check-input').forEach(element => element.setAttribute('checked', true));
    },
    openOtpVerifyModal() {
      const expiryTimeOfOtp = sessionStorage.getItem("ExpiryTime");
      const now = new Date();

      let expiryDate = null;
      if (expiryTimeOfOtp) {
        expiryDate = new Date(expiryTimeOfOtp);
      }

      if (expiryDate instanceof Date && !isNaN(expiryDate.getTime()) && now <= expiryDate) {
        let maskedData = JSON.parse(sessionStorage.getItem("maskedData"));
        maskedData.expiredAt = new Date(expiryDate).toLocaleTimeString();
        sessionStorage.setItem("maskedData", JSON.stringify(maskedData));
        sessionStorage.setItem("OtpExpiryErrorMessage", JSON.stringify({
          type: "error",
          msg: `OTP is sent, expires at ${new Date(expiryDate).toLocaleTimeString()}`
        }))
        this.otpOpenModalFlag = true;
      } else {
        this.resendOtpFromModal();
      }
    },
    resendOtpFromModal() {
      let companyCode = JSON.parse(sessionStorage.getItem('selected_plan_data'))
      this.loadingState = true,
      this.loadingMessage = "Sending OTP...";
      const reqData = {
        distributor: {
          distributorID: this.distributorID,
          agentID: this.getAgentIdFromRmData(this.rmData),
          agentType: this.rmData.RoleId =="4" ? "POSP" : "",
          salesChannel: "",
          channelType: this.rmData.RoleId !== "1" ? "B2B" : "B2C",
          varFields: [
            {
              fieldName: "",
              fieldValue: ""
            }
          ]
        },
        insuranceCompanyCode: companyCode.insuranceAndProducts.insuranceCompanyCode,
        UITrackingRefNo: "0031b045-d539-483f-974b-b87d33ac1e19",
        OTPDetails: {
          mobileNumber: this.proposalDetails.mobile_number,
          email: this.proposalDetails.emailId
        }
      };
      const headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      this.backendApi("getOtpSend", reqData, headers, "post")
        .then((response) => {
          this.loadingState = false;
          if (response === 'error') {
            this.apiError = true;
          } else if (response && response.data) {
            this.otpVerifyResponse = response.data;
            // sessionStorage.setItem("OtpExpiryErrorMessage", null);
            sessionStorage.setItem("ExpiryTime", new Date(this.otpVerifyResponse.data.ExpiryTime).toISOString());
            console.log("maskedData", this.proposalDetails.mobile_number, this.proposalDetails.emailId)
            let maskedNumber  = this.proposalDetails.mobile_number.slice(0, 2) + this.proposalDetails.mobile_number.slice(2).replace(/.(?=...)/g, '*');
            let maskedEmail = this.proposalDetails.emailId.replace(/^(..)(.*)(..@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
            
            console.log("maskedData", maskedNumber, maskedEmail)
            sessionStorage.setItem("maskedData", JSON.stringify({
              mobileNo: maskedNumber,
              email: maskedEmail
            }));
            const expiryTimeOfOtp = sessionStorage.getItem("ExpiryTime");
            let expiryDate = null;
            if (expiryTimeOfOtp) {
              expiryDate = new Date(expiryTimeOfOtp);
            }
            let maskedData = JSON.parse(sessionStorage.getItem("maskedData"));
            maskedData.expiredAt = new Date(expiryDate).toLocaleTimeString();
            sessionStorage.setItem("maskedData", JSON.stringify(maskedData));
            sessionStorage.setItem("OtpExpiryErrorMessage", JSON.stringify({
              type: "error",
              msg: `OTP is sent, expires at ${new Date(expiryDate).toLocaleTimeString()}`
            }))
            sessionStorage.setItem('otpId', JSON.stringify(this.otpVerifyResponse.data.OTPTransactionId));
            this.otpOpenModalFlag = true;
          } else if (response.data.errors.length > 0) {
            this.errorInProposalSubmission = "";
            let ck = 1;
            response.data.errors.forEach(function (element) {
              this.errorInProposalSubmission += ck + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
              ck++;
            });
          }
        })
        .catch((error) => {
          this.loadingState = false;
          console.log(error);
        });
    },
    handleOtpVerifyModal() {
      this.otpOpenModalFlag = false;
    },
    resendOtp() {
      this.resendOtpFromModal();
      this.time = 30;
      this.updateTime();
    },
    updateTime() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timerInterval = setInterval(this.updateCountdown, 1000);
    },
    setErrorMessage(data) {
      let self = this;
      let ck = 1;
      self.errorInProposalSubmission = "";
        data?.errors.forEach(function (element) {
        self.errorInProposalSubmission += ck + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
        ck++;
      });  
      this.loadingState = false;
      this.otpOpenModalFlag = false;
    },
    updateCountdown() {
      if (this.time > 0) {
        this.time -= 1;
      } else {
        clearInterval(this.timerInterval);
      }
    },
    async getCheckPaymentDetails(firstAgain = false) {
      this.errorMsgs = "";
      try {
        this.loadingMessage =  firstAgain ? "Fetching details..." :"Checking Payment Status";
        this.loadingState = true;
        const startTime = Date.now();
        const endTime = startTime + 3 * 60 * 1000;
        const reqData = [this.journey_id, "Payment Details", "false"];
        const headers = {};
        while (Date.now() < endTime) {
          const response = await this.backendApi("getProposalWithStage", reqData, headers, "get");
          if (firstAgain) {
            if (response.data.data && response.data.data?.payment_status && response.data.data?.payment_status !== null && response.data.data?.payment_status?.toLowerCase() === 'success') {
              this.payment_status = response.data?.data?.payment_status;
              return true;
            } else {
              return false;
            }
          } else if (response.data.errors.length === 0) {
            if (response.data.data && response.data.data.payment_status && response.data.data.payment_status !== null) {
              this.applicationNo = response.data.data.proposal_id;
              sessionStorage.setItem("applicationNumber", JSON.stringify(this.applicationNo));
              this.payment_status = response.data.data.payment_status;
              sessionStorage.setItem("payment_poll_status", JSON.stringify(response.data.data.payment_status));
              
              // Don't set loadingState to false here to maintain the loading state
              // during the insurer feedback check and subsequent navigation
              this.loadingMessage = "Getting insurer feedback...";
              await this.getInsurerFeedback();
              if(firstAgain){
                return this.payment_status;
              }
              return;
            }
          }
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        const msg = ['We are facing some issue while getting the information of payment details.'];
        this.errorMsgs = msg;
        this.loadingState = false;
      } catch (error) {
        console.error("An error occurred during payment URL polling:", error);
        this.loadingState = false;
      }
    },
    async getInsurerFeedback() {
      try {
        this.loadingMessage = "Please wait, Getting Information";
        this.loadingState = true;
        const self = this;
        self.errorMsgs = "";
        const startTime = Date.now();
        const endTime = startTime + 3 * 60 * 1000;
        const stage = "Proposal Submitted";
        const reqData = [this.journey_id, stage, "false"];
        const headers = {};
        while (Date.now() < endTime) {
          const response = await this.backendApi("getProposalWithStage", reqData, headers, "get");
          if (response.data.errors.length === 0) {
            if (response.data.data.proposal_response !== null && response.data.data.proposal_response.errors && response.data.data.proposal_response.errors.length > 0) {
              response.data.data.proposal_response.errors.forEach(function (element, index) {
                self.errorInProposalSubmission += (index + 1) + '. ' + stripHtml(element.errorDisplayMsg) + '<br/>';
              });
              this.errorInProposalSubmission = "";
              let ck = 1;
              response.data.errors.forEach(function (element) {
                this.errorInProposalSubmission += ck + '. ' + stripHtml(element.errorDisplayMsg) + '<br/>';
                ck++;
              });
              this.loadingState = false;
              return;
            }
            if (response.data.data.proposal_response !== null && response.data.data.proposal_response.status.code === "200") {
              sessionStorage.setItem('propsalSubmited_afterPayment', JSON.stringify(response.data.data.proposal_response));
              sessionStorage.setItem('afterProposal_payment', JSON.stringify(response.data.data.proposal_details));
              this.getProposalById(this.journey_id);
              if (response?.data?.data?.proposal_response?.ManufacturerTracking?.policyNumber) {
                this.policyNo = response?.data?.data?.proposal_response?.ManufacturerTracking?.policyNumber;
                this.inspectionLink = response?.data?.data?.proposal_response?.inspectionDetails.selfInspectionLink;
                const inspectionvalidTill = response?.data?.data?.proposal_response?.inspectionDetails.inspectionValidTill;
                sessionStorage.setItem("inspectionLink", this.inspectionLink);
                sessionStorage.setItem("inspectionvalidTill", inspectionvalidTill);

                sessionStorage.setItem("policyNo", this.policyNo);
              }
              if (this.payment_status.toLowerCase() === "success") {
                // Keep loading state active
                this.loadingMessage = "Payment successful, getting final status...";
                await this.getProposalStatus();
                return;
              }
              if (this.payment_status.toLowerCase() === "failed") {
                this.loadingMessage = "Redirecting to payment failed page...";
                navigateToPaymentStatusOutcome(this.$router, {
                  outcome: PAYMENT_STATUS_OUTCOME_FAILURE,
                  journeyId: this.journey_id,
                });
                return;
              }
              // this.$router.push('/payment');
              return;
            }
          }
          if (response.data.errors.length > 0) {
            return this.$router.push({
              path: "/error-page",
              query: { msg: response.data.errors[0]["errorMessage"] },
            });
          }
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        this.errorInProposalSubmission = ['We are facing some issue while fetching the data.'];

        this.loadingState = false;
      } catch (error) {
        console.error("An error occurred during payment URL polling:", error);
        this.loadingState = false;
      }
    },
    async getProposalStatus(firstAgain = false) {
      try {
        this.loadingMessage = "Please wait, Getting Information";
        this.loadingState = true;
        const self = this;
        self.errorMsgs = "";
        const reqData = [this.journey_id];
        const headers = {};
        const response = await this.backendApi("getPolicyStatus", reqData, headers, "get");
        const statusRequestId = response.data.reqId;
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach(function (element, index) {
            self.errorMsgs += (index + 1) + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
          });
          const applicationStatus = await this.pollPaymentStatus(statusRequestId, firstAgain);
          if (firstAgain) {
            return applicationStatus;
          }
          this.loadingState = false;
        } else {
          const applicationStatus = await this.pollPaymentStatus(statusRequestId, firstAgain);
          if (firstAgain) {
            return applicationStatus;
          }
        }
        this.loadingState = false;
      } catch (error) {
        this.loadingState = false;
        console.error("An error occurred during payment URL polling:", error);
      }
    },

    async pollPaymentStatus(statusRequestId, firstAgain = false) {
      this.loadingState = true;
      const startTime = Date.now();
      const maxDuration = 3 * 60 * 1000;

      try {
        const reqData = [this.journey_id, statusRequestId];

        while (Date.now() - startTime < maxDuration) {
          this.loadingState = true;
          const response = await this.backendApi("paymentPollStatus", reqData, {}, "get");
          const responseData = response?.data?.data;
          const errors = response?.data?.errors || [];

          if (errors.length > 0) {
            this.loadingState = false;
            break;
          }

          if (responseData?.isPollComplete) {
            this.policyNo = responseData.manufacturer[0].product[0].policyDetails.policyNumber;
            sessionStorage.setItem("policyNo", this.policyNo);
            if(responseData.applicationNumber){
              sessionStorage.setItem("applicationNumber", JSON.stringify(responseData.applicationNumber));
            } else {
              sessionStorage.setItem("applicationNumber", JSON.stringify(responseData.applicationNo));
            }
            sessionStorage.setItem("policy_status", JSON.stringify(responseData.manufacturer[0].product[0].applicationStatus.applicationStatus));
            sessionStorage.setItem("manufacturer_paymentStatus", JSON.stringify(responseData.manufacturer[0].product[0]));

            const applicationStatus = responseData.manufacturer[0].product[0].applicationStatus.applicationStatus;
            if(firstAgain){
              return applicationStatus;
            }
            // Keep the loading state active during navigation to prevent the confirmPayDiy page from showing
            if (applicationStatus === "Policy Issued" || applicationStatus === "Scrutiny" || applicationStatus === "Underwriting") {
              this.loadingMessage = "Redirecting to payment page...";
              this.loadingState = true;
              navigateToPaymentStatusOutcome(this.$router, {
                outcome: PAYMENT_STATUS_OUTCOME_SUCCESS,
                journeyId: this.journey_id,
              });
              return;
            }
            if (applicationStatus === "Inspection Pending") {
              this.loadingMessage = "Redirecting to inspection page...";
              this.loadingState = true;
              navigateToPaymentStatusOutcome(this.$router, {
                outcome: PAYMENT_STATUS_OUTCOME_INSPECTION,
                journeyId: this.journey_id,
              });
              return;
            }
            if (applicationStatus === "Requirements Pending") {
              this.loadingMessage = "Redirecting to pending requirements page...";
              this.loadingState = true;
              navigateToPaymentStatusOutcome(this.$router, {
                outcome: PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
                journeyId: this.journey_id,
              });
              return;
            }
            this.loadingState = false;
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      } catch (error) {
        this.loading = false;
        console.error("Error in pollPaymentStatus:", error);
      }
    },
    displaySubHeading(data){
      let displayFlag = false;
      if (data.fields) {
          for (let key in data.fields) {
            if (data.fields[key].input && data.fields[key].input !== "") {
              displayFlag = true;
            }
          }
        }
        if (data.fieldGroups) {
          for (let key in data.fieldGroups) {
            if (data.fieldGroups[key].input && data.fieldGroups[key].input.trim() !== "") {
              displayFlag = true;
            }
          }
        }
        return displayFlag;
    },
    getCurrentDateAndTime() {
      var today = new Date();
      var year = today.getFullYear();
        var month = today.getMonth()+1;
        var date = today.getDate();
        if(month < 10) {
          month = '0'+month;
        }
        if(date < 10) {
          date = '0'+date;
        }
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        return  year+'-'+month+'-'+date+' '+time;
    },
    async paymentIntimation() {
      try {
        this.loading = true;
        const qData = {
          "journey_id": JSON.parse(sessionStorage.getItem("journey_id")),
          "payment_mode": "UPI",
          "currency_name": "INR",
          "consumer_reference_no": this.payResponse.transactionId,
          "status": "Success",
          "transaction_id": this.payResponse.transactionId,
          "amount": this.tpv.toString(),
          "txn_date": this.getCurrentDateAndTime()
        };

        const headers = {
          "quoteId": this.uiQuoteId,
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
          "Content-Type": "application/json",
        };
        const response = await this.backendApi("paymentIntimation", qData, headers);
        if (response.data.errors.length > 0 || response == "error" || response.status == "error") {
          response.data.errors.forEach(function (element, index) {
            self.errorMsgs += (index + 1) + '. ' + stripHtml(element.errorDisplayMessage) + '<br/>';
          });
          this.loading = false;
          return;
        } else if (response.data.status == 'error') {
          console.log("Payment Intimation Error");
        } else if (response.data) {
          const policyNumber = response?.data?.data?.data?.trackInfo?.policyNumber;
          if(policyNumber){
            this.policyNo = policyNumber;
            sessionStorage.setItem("policyNo", this.policyNo);
          }
          console.log("Payment Intimation Response status:", response.data);
        }
      } catch (error) {
        console.error("Error in paymentIntimation:", error);
        this.loading = false;
        this.errorMsgs += 'An error occurred during payment intimation. Please try again later.<br/>';
      }
    },
     async checkProposalStatus(journeyId) {
      this.loading = true
      let qData = [journeyId];
      var headers = {
        "Content-Type": "application/json",
      };

      try {
        const response = await this.backendApi(
          "getProposalStatus",
          qData,
          headers,
          "get"
        );
        this.loading = false
        if(["Policy Issued","Underwriting","Rejected","Cancelled"].includes(response.data.data.journey_status)){
          this.$router.push({ path: '/read-only-proposal-details', query: { journeyId: journeyId} });
        }

      } catch (error) {
        console.log("Error:", error);
      }
    }
  },
  async mounted() {
    this.configData = this.$store.state.configData;
    this.distributorID = getDistributer()["distributerID"];
    this.selected_plan_data = JSON.parse(sessionStorage.getItem("selected_plan_data"));
    this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
    this.selectedPlan = JSON.parse(sessionStorage.getItem("selected_plan_data"));
    this.channelType = JSON.parse(sessionStorage.getItem('diy'));
    this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING = this.$store.state.configData.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING
    if (sessionStorage.getItem("userData")) {
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      this.PANNumber = userData.PANNumber;
    }

    if (sessionStorage.getItem("journey_id")) {
      this.journey_id = JSON.parse(sessionStorage.getItem("journey_id"));
    } else if (this.$route.query.journeyId) {
      this.journey_id = JSON.parse(this.$route.query.journeyId);
    }
     this.checkProposalStatus(this.journey_id)
    sessionStorage.setItem("journey_id", JSON.stringify(this.journey_id));
    this.loadingState = true;

    // PG return (health-style or legacy) → /payment-status
    const q = this.$route.query || {};
    if (q.action === 'payment' || q.referenceId || q.reference_id || q.response) {
      this.$router.replace({ path: PAYMENT_STATUS_PATH, query: { ...q } });
      return;
    }

    try {
      const diyErrorRaw = sessionStorage.getItem(DIY_PROPOSAL_ERROR_STORAGE_KEY);
      if (diyErrorRaw) {
        const diyError = JSON.parse(diyErrorRaw);
        if (diyError?.message) {
          this.errorInProposalSubmission = diyError.message;
        }
        sessionStorage.removeItem(DIY_PROPOSAL_ERROR_STORAGE_KEY);
      }
    } catch {
      /* ignore */
    }

    const status = await this.getCheckPaymentDetails(true);
    if (status) {
      navigateToPaymentStatusOutcome(this.$router, {
        outcome: PAYMENT_STATUS_OUTCOME_SUCCESS,
        journeyId: this.journey_id,
      });
      return;
    }
    await this.getProposalById(this.journey_id);
    if (sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    }
    this.quoteCategory = this.$store.state.quoteCategory;
  },
  data() {
    return {
      apiReqData:'',
      SQ_CALL_BEFORE_PROPOSAL:null,
      Sqflag:false,
      Verifypremiumflag:false,
      channelType:null,
      selectedPlan:'',
      // pollapiflag:false,
      distributorID:'',
      inspectionLink:"",
      payResponse: "",
      loadingState: false,
      loadingMessage: "",
      time: 30,
      timerInterval: null,
      otpExpiryTime: "",
      journey_id: "",
      otpOpenModalFlag: false,
      otpVerifyResponse: null,
      structuredJSON: {},
      userDetails: {},
      quoteDetails: {},
      proposalDetails: {},
      responseData: [],
      errorInProposalSubmission: "",
      openAmountBreakupflag:false,
      PANNumber:'',
      PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING:'',
      displayApiErrorsOnUI: [],
      productHeaderMount: false,
      quoteRequest: {},
      quoteCategory: "",
      items: [
        {
          rmData: null,
          selected_plan_data: null,
          quote_request: null,
          heading: "Plan Summary",
          BankLogo: "$SBI",
          planType: "Plan Type",
          plan: "₹ 14,560",
          coverType: "IDV Cover",
          cover: "₹13,36,452",
          nestedItems: [
            {
              checkitems: "Zero Paper Claims",
            },
            {
              checkitems: "Spot Claims Upto Rs. 20k",
              carcover: "₹ 14,560",
            },
            {
              checkitems: "28 Cashless Garages",
            },
            {
              checkitems: "Self-Video Claims",
            },
          ],
          premiumAmount: "Premium Amount",
          amount: "₹ 14,560",
          GSTType: "GST @18%",
          GST: "₹ 2620",
          amountTitle: "Total Amount",
          totalAmount: "₹ 17,180",
        },
      ],
      Addon: [
        {
          checkheadings: "Zero Paper Claims",
        },
        {
          checkheadings: "Spot Claims Upto Rs. 20k",
        },
        {
          checkheadings: "28 Cashless Garages",
        },
        {
          checkheadings: "Self-Video Claims",
        },
      ],
      Additions: [
        {
          id: 1,
          accoheading: "Owner Details",

          expanded: true,
          nestedItems: [
            {

              checkContent: "Akash Chopra",
              subcheck: "Name",
            },
            {

              checkContent: "+91 8888 38888",
              subcheck: "Mobile",
            },
            {

              checkContent: "16/04/1986",
              subcheck: "Date Of Birth",
            },
            {

              checkContent: "AUK37878K",
              subcheck: "PAN",
            },
            {

              checkContent: "Male",
              subcheck: "Gender",
            },
            {

              addressContent: "328/330, Mangaldas Market, opposite Jumma Masjid, Mumbai, Maharashtra 400002, India",
              address: "Address",
            },

          ],
        },
        {
          id: 2,
          accoheading: "Vehicle Details",

          expanded: true,
          nestedItems: [
            {

              checkContent: "1887787377",
              subcheck: "Engine Number",
            },
            {

              checkContent: "299898798788",
              subcheck: "Chassis Number",
            },
            {

              checkContent: "Yes",
              subcheck: "Is your vehicle taken on loan?",
            },
            {

              checkContent: "SBI Auto Loan",
              subcheck: "Financier",
            },


          ],
        },
        {
          id: 3,
          accoheading: "Previous Policy Details",

          expanded: true,
          nestedItems: [

            {
              subcontent: "Own Damage Detail",
              checkContent: "SBI",
              subcheck: "Insurer",
            },
            {

              checkContent: "12/06/2025",
              subcheck: "Policy Expiry Date",
            },
            {

              checkContent: "99389898",
              subcheck: "Policy Number",
            },



          ],
        },

      ],
      condition: false,
      tpv: "",
      configData: "",
      checkedConditions: [],
    };
  },
  computed: {
    resolveImagePath() {
      return (variable) => {
        // Map the SCSS variable name to its actual value
        const variableMap = {
          $SBI: "/images/state-bank-of-india-logo.svg", // Match this to your SCSS variable definition
        };
        return variableMap[variable] || "";
      };
    },
    filteredStructureJson() {
      const checkInputValues = (obj) => {
        if (obj.fields) {
          for (let key in obj.fields) {
            if (obj.fields[key].input && obj.fields[key].input.trim() !== "") {
              return true;
            }
          }
        }
        if (obj.fieldGroups) {
          for (let key in obj.fieldGroups) {
            if (checkInputValues(obj.fieldGroups[key])) {
              return true;
            }
          }
        }
        return false;
      };
      return this.structuredJSON.otherRequiredFields && this.structuredJSON.otherRequiredFields.filter(container => checkInputValues(container));
    },
    isEditButton(){
      return this.userDetails && this.userDetails.RoleId && this.userDetails.RoleId === "1";
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";
@import "../../assets/scss/components/multi-quotes.scss";
@import "../../assets/scss/components/form-wizard.scss";

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s cubic-bezier(0.215, 0.610, 0.355, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.diy_left-panel{
background-color: $commonColor !important;
}

.errorMessage {
  color: rgb(255, 94, 94);
  font-size: 14px;
}
.condition-container{
  display: grid;
  grid-template-columns: 20px 1fr;
  input, label{
    display: inline-block;
  }
  label{
    transform: translateY(-4px);
  }
  input[type="checkbox"]{
    width: 18px;
    height: 18px;
  }
} 
.editButton{
  width: 18px !important;
  height: auto;
}
.edit_text{
  font-size: 14px !important;
  margin-top: 4px !important;
  color: $main-bg;
}
.descliminar{
  font-size: 12px;
  margin-left: 10px;
  text-align: left;
  cursor: pointer;
  line-height: 18px;
  opacity: 0.8;
  &:hover{
    opacity: 1;
  }
}
.grid-view{
  // display: grid;
  // grid-template-columns: repeat ( 2, 1fr);
}
.mandatory-mark{
  color: $alert !important;
}
.dark .descliminar{
  color:$text-darkColor;
  font-size: 12px;
}
.dark .FilterAccordian {
  background-color: $header-dark-bg !important;
}

.dark{
  .diy_left-panel{
    background-color: $header-dark-bg !important;
  }
}

/* New styles for improved aesthetics */
.review-panel {
  background-color: $commonColor;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dark .review-panel {
  background-color: $cardBackgroundDark;
}

.FilterAccordian {
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.question-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.headingcards {
  border: 1px solid #eaeaea;
}

.dark .headingcards {
  border: 1px solid #3a3a3a;
}

.text-uppercase {
  font-weight: 600 !important;
  letter-spacing: 0.5px;
}

.processheading {
  position: relative;
}

.commonButton {
  border-radius: 4px;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.commonButton:hover {
  transform: translateY(-2px);
}
</style>
